module.exports = __webpack_public_path__ + "static/media/inputArrowDark.ded8cc3b.svg";